import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/components/Login'
import Auth from '@/components/auth/SetPassword'



import Dashboard from '@/components/start/Dashboard'
import Menus from '@/components/administrador/Menus'

import Menu from '@/components/administrador/menus/Menu'
import Submenus from '@/components/administrador/submenus/Submenus'
import ManageUsers from '@/components/users/Manage'
import CreateUsers from '@/components/users/Create'
import AdminRoles from '@/components/roles/Manage'
import CreateRoles from '@/components/roles/Create'

import Compania from '@/components/parametrizacion/Compania'
import Divipol from '@/components/consultas/Divipol'
import Ciius from '@/components/consultas/Ciius'
import Saldos from '@/components/consultas/Saldos'

import ResumenInfo from '@/components/impuestos/ResumenInfo'
import LiquidacionInfo from '@/components/impuestos/LiquidacionInfo'


import store from '../store'
const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/administrador',
    name: 'administrador',
    component: Menus,
  },
  {
    path: '/submenus',
    name: 'submenus',
    component: Submenus
  },
  {
    path: '/menus',
    name: 'menus',
    component: Menu,
  },
  {
    path: '/users',
    name: 'users',
    component: ManageUsers,
  },
  {
    path: '/users/create',
    name: 'users-create',
    component: CreateUsers,
  },
  {
    path: '/roles',
    name: 'roles',
    component: AdminRoles,
  },
  {
    path: '/roles/create',
    name: 'roles-create',
    component: CreateRoles,
  },
  {
    path: '/home',
    name: 'home',
    component: Dashboard,
  },
  {
    path: '/account',
    name: 'account',
    component: Auth
  },  


  {
    path: '/parametrizacion',
    name: 'parametrizacion',
    component: Menus,
  },
  {
    path: '/paracompania',
    name: 'paracompania',
    component: Compania,
  },

  {
    path: '/condivipol',
    name: 'condivipol',
    component: Divipol,
  },
  {
    path: '/conciiu',
    name: 'conciiu',
    component: Ciius,
  },
  {
    path: '/coningresos',
    name: 'coningresos',
    component: Saldos,
  },

  {
    path: '/impresumen',
    name: 'impresumen',
    component: ResumenInfo,
  },

  {
    path: '/impliquidacion',
    name: 'impliquidacion',
    component: LiquidacionInfo,
  },


  {
    path: '/cargues',
    name: 'cargues',
    component: Menus,
  },
  {
    path: '/consultas',
    name: 'consultas',
    component: Menus,
  },
  {
    path: '/impuestos',
    name: 'impuestos',
    component: Menus,
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && to.name !== 'account' && to.name !== 'registration' && !store.state.isAuthenticated) next({ name: 'login' })
  else next()
})

export default router
